import { app } from "src/core/app";
import { useTranslation } from "src/i18n";
import { Languages } from "src/core/constants";
import { IconText } from ".";

export function LanguageSwitch() {
    const { language, t } = useTranslation();
    const newLangage = language === Languages.en ? Languages.zhHK : Languages.en;
    return (
        <div className="eac-language-switch">
            <a href={app.route.getPath({ ...app.route.toJSON(), language: newLangage })}>
                <IconText icon="globe">{t(`common.lang.${newLangage}`)}</IconText>
            </a>
        </div>
    );
}
